<template>
  <div class="goods-detail-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <div class="card-content" v-loading="goodsLoading">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-carousel indicator-position="none" style="text-align: center;width: 100%;" height="400">
                  <el-carousel-item v-for="img in goodsData.imgList" style="width: 100%;height: 100%;">
                    <img :src="img" :alt="goodsData.goods_name" style="max-height: 100%;max-width: 100%">
                  </el-carousel-item>
                </el-carousel>
              </el-col>
              <el-col :span="14">
                <div class="goods-info">
                  <p class="goods-all-name">
                    {{goodsData.goods_all_name}}
                  </p>
                  <div class="category">
                    {{goodsData.goods_classify}}
                  </div>
                  <div class="price">
                    <i class="el-icon-coin"/> {{goodsData.goods_price}}
                  </div>
                  <div class="stock">
                    <span>库存：{{goodsData.goods_stock}}</span><span style="margin-left: 20px;">已兑换：{{goodsData.exchange}}</span>
                  </div>
                  <div class="receive">
                    <span v-if="goodsData.recive===0">领取方式：邮寄</span>
                    <span v-if="goodsData.recive===1">领取方式：兑换码兑换</span>
                  </div>
                  <div class="button">
                    <el-button :loading="btnLoading"  @click="changeGoods" style="background-color:#df3033;color: white;" size="medium" icon="el-icon-goods">立即兑换</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:15px;">
              <el-col :span="24">
                <div v-html="goodsData.goods_content"></div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-row>
    <el-dialog
      title="收货信息"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form :model="formData" :rules="rules" ref="ruleForm" size="small" label-width="80px">
        <el-form-item label="收件人" prop="recipient">
          <el-input v-model="formData.recipient"/>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="formData.tel"/>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input type="textarea" v-model="formData.address"/>
        </el-form-item>
        <el-form-item>
          <el-button :loading="btnLoading" type="primary" @click="changeBySend('ruleForm')">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getGoodsDetail} from '@/api/my'
import { buyGoods} from '@/api/my'
import { validatePhoneNumber } from '@/utils/validate'

export default {
  name: 'goods_detail',
  computed: {
    user: getUser
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.id = this.$route.params && this.$route.params.id
    this.getGoodsDetail()
  },
  data(){
    const validatePhone = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return{
      goodsData: {},
      goodsLoading: false,
      btnLoading: false,
      dialogVisible: false,
      formData: {
        recipient: '',
        tel: '',
        address: ''
      },
      rules: {
        recipient:[
          { required: true, message: '请输收件人', trigger: 'blur'},
        ],
        tel: [
          { required: true, message: '请填写正确的电话', trigger: 'blur'},
          { validator: validatePhone, message: '请填写正确的电话', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    getGoodsDetail(){
      this.goodsLoading = true
      getGoodsDetail({goodsid: this.id}).then(response=>{
        this.goodsData = response.data
        this.goodsLoading = false
        this.setTagsViewTitle()
        this.setPageTitle()
      }).catch(()=>{
        this.goodsLoading = false
      })
    },
    setTagsViewTitle() {
      const route = Object.assign({}, this.tempRoute, { title: `商品详情 - ${this.goodsData.goods_name}` })
      this.$store.dispatch('tagsView/updateVisitedView', route)
    },
    setPageTitle() {
      const title = '商品详情'
      document.title = `${title} - ${this.goodsData.goods_name}`
    },
    changeGoods(){
      //兑换码
      if(this.goodsData.recive===1){
        this.$confirm(`您确定花费${this.goodsData.goods_price}积分兑换此商品吗?`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          this.btnLoading = true
          const data = {
            type: this.goodsData.recive,
            goodsid: this.id,
            recipient: this.formData.recipient,
            tel: this.formData.tel,
            address: this.formData.address,
            userid: this.user.dUserid
          }
          buyGoods(data).then(response=>{
            this.$message({
              type: 'success',
              message: '兑换成功'
            })
            this.btnLoading = false
          }).catch(() => {
            this.btnLoading = false
          });
        })
      }else {//邮寄
        this.dialogVisible = true
      }
    },
    handleClose(done){
      this.formData.recipient = ''
      this.formData.address = ''
      this.formData.tel = ''
      done();
    },
    changeBySend(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const data = {
            type: this.goodsData.recive,
            goodsid: this.id,
            recipient: this.formData.recipient,
            tel: this.formData.tel,
            address: this.formData.address,
            userid: this.user.dUserid
          }
          buyGoods(data).then(response=>{
            this.$message({
              type: 'success',
              message: '兑换成功'
            })
            this.btnLoading = false
            this.dialogVisible = false
          }).catch(() => {
            this.btnLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .goods-info{
    .category{
      font-size: 14px;
      margin-bottom: 15px;
    }
    .goods-all-name{
      font-size: 18px;
    }
    .price{
      color:#e01222;
      font-size: 18px;
      margin-bottom: 18px;
    }
    .stock{
      color:#99a9bf;
      font-size: 14px;
      margin-bottom: 18px;
    }
    .receive{
      font-size: 14px;
      margin-bottom: 18px;
    }
  }
</style>
